class LLPluginEnhance {
    constructor() {
        this.recordKey = 'll-plugin-properties-customize-text'
        
        this.input = document.querySelector("input[name='properties-customize-text']")
        this.checkbox = document.querySelector("#personalise-me")
        this.button = document.querySelector(".j-ll-btn-apply")
        this.formInput = document.querySelector("#properties-customize-text")

        this.listen()
        this.refill()
    }

    listen() {
        this.button.addEventListener("click", (e) => {
            const value = this.input.value
            this.record(value)
        })

        this.checkbox.addEventListener("change", (e) => {
            const checked = e.target.checked

            if (checked === false) {
                clearCustomizeInfo()
            }

            if (checked && !this.input.value) {
                document.getElementById("modal-customize").show();
            }
        })
    }

    record(value) {
        sessionStorage.setItem(this.recordKey, value)
    }

    refill() {
        const value = sessionStorage.getItem(this.recordKey)
        if (value) {
            this.input.value = value
            this.checkbox.checked = true
            this.formInput.value = value

            engravingsText && engravingsText(this.input)

            sessionStorage.removeItem(this.recordKey)
        }
    }
}

const llPluginEnhance = new LLPluginEnhance()